// extracted by mini-css-extract-plugin
export default {"waveLoader":"LazyImage_waveLoader__iK9fV"};